export const CONTEXT_MENU_DELETE_PREVIEW_Z_INDEX = 14;
